import { render, staticRenderFns } from "./TMAlert.vue?vue&type=template&id=bb1e6faa"
import script from "./TMAlert.vue?vue&type=script&lang=js"
export * from "./TMAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports